import styled from 'styled-components';

// *** Components ***
export const ThemeModeSwitcher = styled.div``;
